export const PROPERTY_FEATURE_CATEGORY_TYPES = {
  0: 'Inside',
  100: 'Outside',
  200: 'Location',
  300: 'Eco',
  400: 'Other',
}
